<template>
    <v-form
        class="registration-form-step2"
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validateAndSubmit"
    >
        <div class="registration-form-step2__section" v-if="profileInfoVisible">
            <h3 class="registration-form-step2__section-title">
                {{ profileInfoSectionTitle }}
            </h3>
            <v-row>
                <v-col v-if="fnameField_visible" :cols="isLessThan480 ? '12' : '6'" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('user_fname')}"
                        color="red"
                        v-model="fields.user_fname"
                        :error-messages="field_errors.user_fname"
                        :rules="rules.user_fname"
                        required
                        :placeholder="fnameTitle"
                    />
                </v-col>
                <v-col v-if="lnameField_visible" cols="isLessThan480 ? '12' : '6'" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('user_lname')}"
                        color="red"
                        v-model="fields.user_lname"
                        :error-messages="field_errors.user_lname"
                        :rules="rules.user_lname"
                        required
                        :placeholder="lnameTitle"
                    />
                </v-col>
            </v-row>
        </div>
        <div class="registration-form-step2__section" v-if="companyInfoVisible">
            <h3 :class="{'registration-form-step2__section-title': true, 'mt-3': profileInfoVisible}">
                {{ companyInfoSectionTitle }}
            </h3>
            <v-row>
                <v-col v-if="companyField_visible" cols="12" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('user_company')}"
                        color="red"
                        v-model="fields.user_company"
                        :error-messages="field_errors.user_company"
                        :rules="rules.user_company"
                        required
                        :placeholder="companyTitle"
                    />
                </v-col>
                <v-col v-if="occupationField_visible" cols="12" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('user_occupation')}"
                        color="red"
                        v-model="fields.user_occupation"
                        :error-messages="field_errors.user_occupation"
                        :rules="rules.user_occupation"
                        required
                        :placeholder="occupationTitle"
                    />
                </v-col>
            </v-row>
        </div>
        <div class="registration-form-step2__section" v-if="workAddressVisible">
            <h3 :class="{'registration-form-step2__section-title': true, 'mt-3': companyInfoVisible}">
                {{ addressSectionTitle }}
            </h3>
            <v-row>
                <v-col v-if="firstAddressField_visible" cols="12" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_line1')}"
                        color="red"
                        v-model="fields.address.Work.address_line1"
                        :error-messages="field_errors.address_line1"
                        :rules="rules.address_line1"
                        required
                        :placeholder="addressLine1Title"
                    />
                </v-col>
                <v-col v-if="secondAddressField_visible" cols="12" class="py-0">
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_line2')}"
                        color="red"
                        v-model="fields.address.Work.address_line2"
                        :error-messages="field_errors.address_line2"
                        :rules="rules.address_line2"
                        required
                        :placeholder="addressLine2Title"
                    />
                </v-col>
                <v-col
                    v-if="cityField_visible"
                    class="py-0"
                    :cols="isLessThan480 ? '12' : stateField_visible ? '6' : '12'"
                >
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_city')}"
                        color="red"
                        v-model="fields.address.Work.address_city"
                        :error-messages="field_errors.address_city"
                        :rules="rules.address_city"
                        required
                        :placeholder="addressCityTitle"
                    />
                </v-col>
                <v-col
                    v-if="stateField_visible"
                    class="py-0"
                    :cols="isLessThan480 ? '12' : cityField_visible ? '6' : '12'"
                >
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_state')}"
                        color="red"
                        v-model="fields.address.Work.address_state"
                        :error-messages="field_errors.address_state"
                        :rules="rules.address_state"
                        required
                        :placeholder="addressStateTitle"
                    />
                </v-col>
                <v-col
                    v-if="zipField_visible"
                    class="py-0"
                    :cols="isLessThan480 ? '12' : countryField_visible ? '6' : '12'"
                >
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_zip')}"
                        color="red"
                        v-model="fields.address.Work.address_zip"
                        :error-messages="field_errors.address_zip"
                        :rules="rules.address_zip"
                        required
                        :placeholder="addressZipTitle"
                        type="number"
                    />
                </v-col>
                <v-col
                    v-if="countryField_visible"
                    class="py-0"
                    :cols="isLessThan480 ? '12' : zipField_visible ? '6' : '12'"
                >
                    <v-text-field
                        :class="{'pt-0 field': true, 'field-required': isFieldRequired('first_address_country')}"
                        color="red"
                        v-model="fields.address.Work.address_country"
                        :error-messages="field_errors.address_country"
                        :rules="rules.address_country"
                        required
                        :placeholder="addressCountryTitle"
                    />
                </v-col>
            </v-row>
        </div>
        <v-btn
            v-if="signUpButtonTitle"
            class="registration-form-step2__submit elevation-0"
            type="submit"
            :loading="isLoading"
        >
            {{ signUpButtonTitle }}
        </v-btn>
    </v-form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Form from '@/mixins/Form'
import { ruleRequired } from '@/utils/rules'
export default {
    mixins: [Form],
    props: {
        initFields: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            fields: {
                user_fname: '',
                user_lname: '',
                user_company: '',
                user_occupation: '',
                address: {
                    Work: {
                        address_line1: '',
                        address_line2: '',
                        address_city: '',
                        address_state: '',
                        address_zip: '',
                        address_country: ''
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions('auth', ['signUp']),

        isFieldRequired(field) {
            if (this.backUser) {
                return this.requiredFormFields.some(item => item === field)
            }
            return false
        },
        async submitForm() {
            if (!this.isLoading) {
                const result = await this.signUp(this.fields)
                if (result) {
                    this.$router.push({
                        name: 'login'
                    })
                } else {
                    this.$emit('stepBack')
                }
            }
        }
    },
    computed: {
        ...mapGetters('settings', ['backUser', 'login', 'registration_fields']),
        ...mapGetters('auth', ['isLoading']),

        isLessThan480() {
            return this.$vuetify.breakpoint.width <= 480
        },
        rules() {
            return {
                user_fname: [
                    (v) => this.isFieldRequired('user_fname') ? ruleRequired(v) || 'Field is required.' : []
                ],
                user_lname: [
                    (v) => this.isFieldRequired('user_lname') ? ruleRequired(v) || 'Field is required.' : []
                ],
                user_company: [
                    (v) => this.isFieldRequired('user_company') ? ruleRequired(v) || 'Field is required.' : []
                ],
                user_occupation: [
                    (v) => this.isFieldRequired('user_occupation') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_line1: [
                    (v) => this.isFieldRequired('first_address_line1') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_line2: [
                    (v) => this.isFieldRequired('first_address_line2') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_city: [
                    (v) => this.isFieldRequired('first_address_city') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_state: [
                    (v) => this.isFieldRequired('first_address_state') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_zip: [
                    (v) => this.isFieldRequired('first_address_zip') ? ruleRequired(v) || 'Field is required.' : []
                ],
                address_country: [
                    (v) => this.isFieldRequired('first_address_country') ? ruleRequired(v) || 'Field is required.' : []
                ],
            }
        },
        formFields() {
            if (this.backUser) {
                return this.backUser.registration_fields.split(',')
            }
            return null
        },
        requiredFormFields() {
            if (this.backUser) {
                return this.backUser.registration_required_fields.split(',')
            }
            return null
        },
        fnameField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'user_fname')
            }
            return false
        },
        lnameField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'user_lname')
            }
            return false
        },
        profileInfoVisible() {
            return this.fnameField_visible || this.lnameField_visible
        },
        companyField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'user_company')
            }
            return false
        },
        occupationField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'user_occupation')
            }
            return false
        },
        companyInfoVisible() {
            return this.companyField_visible || this.occupationField_visible
        },
        firstAddressField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_line1')
            }
            return false
        },
        secondAddressField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_line2')
            }
            return false
        },
        cityField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_city')
            }
            return false
        },
        stateField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_state')
            }
            return false
        },
        zipField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_zip')
            }
            return false
        },
        countryField_visible() {
            if (this.formFields) {
                return this.formFields.some(item => item === 'first_address_country')
            }
            return false
        },
        workAddressVisible() {
            return this.firstAddressField_visible
            || this.secondAddressField_visible
            || this.cityField_visible
            || this.stateField_visible
            || this.zipField_visible
            || this.countryField_visible
        },
        signUpButtonTitle() {
            if (this.login) {
                return this.login.signup_button
            }
            return null
        },
        profileInfoSectionTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_fname').section
            }
            return 'Profile Info'
        },
        companyInfoSectionTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_company').section
            }
            return 'Company Info'
        },
        addressSectionTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_line1').section
            }
            return 'Work Address'
        },
        fnameTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_fname').title
            }
            return 'First Name'
        },
        lnameTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_lname').title
            }
            return 'Last Name'
        },
        companyTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_company').title
            }
            return 'Company'
        },
        occupationTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'user_occupation').title
            }
            return 'Occupation'
        },
        addressLine1Title() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_line1').title
            }
            return 'Street Address 1'
        },
        addressLine2Title() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_line2').title
            }
            return 'Street Address 2'
        },
        addressCityTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_city').title
            }
            return 'City'
        },
        addressStateTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_state').title
            }
            return 'State'
        },
        addressZipTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_zip').title
            }
            return 'ZIP'
        },
        addressCountryTitle() {
            if (this.registration_fields) {
                return this.registration_fields.find(field => field.field === 'first_address_country').title
            }
            return 'Country'
        }
    },
    created() {
        this.fields = {...this.fields, ...this.initFields}
    },
    beforeDestroy() {
        this.$emit('cacheFields', this.fields)
    }
}
</script>
<style lang="scss">
.registration-form-step2 {
    &__section {
        &-title {
            font-size: 18px;
            font-weight: 700;
            color: #4A4A4A;
            line-height: 21.94px;
            margin-bottom: 12px;
        }
    }

    &__submit {
        width: 100%;
        height: 50px !important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 700;
        color: #fff !important;
        line-height: 21.94px;
        text-transform: capitalize;
        background-color: var(--button-main-background-color) !important;
        margin-top: 32px;
    }

    .theme--light.v-input input {
		color: #000;
	}

	.field {
		input {
			font-size: 13px;
			font-weight: 500;
			max-height: 50px;
			padding-left: 10px;
		}
		.v-input__slot {
			border-bottom: 1px solid rgba(0, 0, 0, 0.6);
		}
	}

	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		color: #e5e5e5;
		border-color: #e5e5e5;
	}

	input::placeholder {
		color: #9B9B9B !important;
		opacity: 1;
	}

    .field-required::after {
        content: ' *';
        color: red;
        position: relative;
        top: 10px;
    }
}
</style>